
export function ListCell(props) {

    const getValue = e => {
        if (e) {
            if (props.attribute) {
                let names = [];
                /* eslint-disable array-callback-return */
                e.map((item) => {
                    // console.log(item)
                    names.push(item[props.attribute])
                });
                return names.join(props.delimiter);
            } else {
                return e.join(props.delimiter);
            }
        } else {
            return "";
        }
    }

    return getValue(props.cell.value);
}